module.exports = __webpack_public_path__ + "static/media/MIAB9471-180730-69_Small.532462df.jpg";